import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { IDeviceDynamicState } from "./DeviceStateInterfaces";
import DeviceStateService from "./DeviceStateService";
import { EBrowser, EDeviceScreenWidth } from "./DeviceStateEnums";

interface IProps {
  deviceStateService: DeviceStateService
}

export interface IDeviceStateControllerReturn {
  //states
  appIsInitialized: boolean; setAppIsInitialized: Dispatch<SetStateAction<boolean>>;
  //deviceDynamicState: IDeviceDynamicState;
  eDeviceScreenState: EDeviceScreenWidth;
  /** *   tiny or smaller */
  tiny: boolean,
  /** *   small or smaller */
  small: boolean;
  /** *   medium or smaller */
  medium: boolean;
  isLandscape: boolean;
  isMobileLandscape: boolean;
  //vars
  //deviceStateService: DeviceStateService,
  isMobile: boolean;
  //functions
  currentBrowserIsOneOfGivenBrowsers(enums: EBrowser[]): boolean ;
  screenHeight(): number;
  screenWidth(): number;
}

export const DeviceStateController = (props: IProps): IDeviceStateControllerReturn => {
  //alert("DeviceStateController")
  const tag = "DeviceStateController";

  //#region vars
  //const deviceStateService = props.deviceStateService;
  const isMobile = props.deviceStateService.isMobileDevice();
  var screenWidthPre = 0;
  //#endregion

  //#region states
  const [deviceDynamicState, setDeviceDynamicState] = useState<IDeviceDynamicState>(props.deviceStateService.getDeviceDynamicState()); 
  useEffect(() => {
    setEDeviceScreenState(deviceDynamicState.eDeviceScreenState)
    setIsLandscape(deviceDynamicState.isLandscapeOrientation()) 
  }, [deviceDynamicState]);


  const [eDeviceScreenState, setEDeviceScreenState] = useState<EDeviceScreenWidth>(EDeviceScreenWidth.Large);
    useEffect(() => {
      setIsMediumScreen((eDeviceScreenState.valueOf() <= EDeviceScreenWidth.Large.valueOf()) ? true : false)
      //small or smaller
      setIsSmallScreen((eDeviceScreenState.valueOf() <= EDeviceScreenWidth.Small.valueOf()) ? true : false)
      //tiny or smaller
      setIsTiny((eDeviceScreenState.valueOf() <= EDeviceScreenWidth.Tiny.valueOf()) ? true : false)
  }, [eDeviceScreenState]);

  const [isMobileLandscape, setIsMobileLandscape] = useState<boolean>(false); 
  const [isLandscape, setIsLandscape] = useState<boolean>(false);
  useEffect(() => {
    if (isMobile && isLandscape) {
      setIsMobileLandscape(true);
    } else {
      setIsMobileLandscape(false);
    }
  }, [isLandscape]);

  //const [isIsPortrait, setIsPortrait] = useState<boolean>(false); 

  const [medium, setIsMediumScreen] = useState<boolean>(true);
  const [small, setIsSmallScreen] = useState<boolean>(true);
  const [tiny, setIsTiny] = useState<boolean>(true);

  const [appIsInitialized, setAppIsInitialized] = useState<boolean>(false);
  //#endregion

  //#region functions
  const screenHeight = (): number => {
    return deviceDynamicState.screenHeight
  }

  const screenWidth = (): number => {
    return deviceDynamicState.screenWidth
  }
  //#endregion

  useEffect(() => {
    handleResize();
    addSelfAsListener()
    return () => {
      removeSelfAsListener();
    }
  }, []);

  
  //#region listener
  const addSelfAsListener = () => {  
    window.addEventListener('deviceorientation',()=>handleResize());
    window.addEventListener('resize',()=>handleResize());
  }
  
  const removeSelfAsListener = () => {
    window.removeEventListener('deviceorientation', ()=>handleResize());
    window.removeEventListener('resize',()=>handleResize());
  }
  //#endregion


  //handler
  const handleResize = (force: boolean = false) => {
    //setTimeout(() => {
      const state = props.deviceStateService.getDeviceDynamicState();
      if (!force && !deviceStateHasChanged(state)) return;
      setDeviceDynamicState(state);
    //}, 2000);
  };

  const deviceStateHasChanged = (state: IDeviceDynamicState): boolean => {
    if(screenWidthPre == state.screenWidth) return false;
    screenWidthPre = state.screenWidth;
    return true;
  }

  const currentBrowserIsOneOfGivenBrowsers = (enums: EBrowser[]): boolean => {
    return props.deviceStateService.currentBrowserIsOneOfGivenBrowsers(enums)
  }


  return {
    //states
    appIsInitialized,setAppIsInitialized,
    //deviceDynamicState,
    eDeviceScreenState,
    tiny,small,medium,
    isLandscape,
    isMobileLandscape,
    //vars
    //deviceStateService,
    isMobile,
    //functions
    currentBrowserIsOneOfGivenBrowsers,
    screenHeight,
    screenWidth
  }
}
